import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { Package } from "react-feather";
import { X } from "react-feather";

interface IProps {
	isOpen: boolean;
	toggleForm: () => void;
	title: string;
	reset?: () => void;
}

const SideForm: React.FC<IProps> = (props) => {
	// Prevent body scroll when form is open
	useEffect(() => {
		if (props.isOpen) {
			// Store the original overflow value
			const originalOverflow = document.body.style.overflow || '';
			// Prevent background scrolling
			document.body.style.overflow = 'hidden';
			
			// Cleanup: restore original overflow when form closes or component unmounts
			return () => {
				document.body.style.overflow = originalOverflow;
			};
		}
		// Note: We don't set overflow to '' here because the cleanup function handles it
	}, [props.isOpen]);

	useEffect(() => {
		if (!props.isOpen && props.reset) {
			props.reset();
		}
	}, [props.isOpen]);

	const getFormIcon = () => {
		if (props.title == "Edit Ingredient" || props.title == "Add Ingredient")
			return <i className="mr-3 icon-nav-ingredients" style={{ color: "#f4a850", fontSize: 36 }} />;
		if (props.title == "Edit Product" || props.title == "Add Product")
			return <Package size={46} className="color-bg-blue mr-3" />;

		return <Package size={46} className="color-bg-blue mr-3" />;
	};

	return ReactDOM.createPortal(
		<div className={`side-form ${props.isOpen ? "show" : ""}`}>
			<div className="overlay" onClick={props.toggleForm} />

			<div className="content">
				<div className="title">
					<div className="d-flex align-items-center">
						{getFormIcon()}
						<h3 className="mb-0">{props.title}</h3>
					</div>

					<div onClick={props.toggleForm}>
						{" "}
						<X />
					</div>
				</div>
				{props.children}
			</div>
		</div>,
		document.body
	);
};

export default SideForm;
